import { Button } from "@/components/ui/button";
import { useThemeConfig } from "@/components/ui/theme-config-provider";

interface ImportListInputProps {
  text: string;
  setText: (v: string) => void;
  onParse: () => void;
  onCancel: () => void;
}

const ImportListInput = ({ text, setText, onParse, onCancel }: ImportListInputProps) => {
  const { theme } = useThemeConfig();
  return (
    <>
      <textarea
        value={text}
        onChange={(e) => setText(e.target.value)}
        rows={3}
        className="w-full p-2 border rounded min-h-[6rem]"
        style={{
          backgroundColor: theme.inputBackgroundColor || theme.backgroundColor,
          color: theme.textColor,
          borderColor: theme.inputBorderColor,
          borderRadius: theme.inputBorderRadius || theme.borderRadius,
        }}
      />
      <div className="flex justify-between mt-4">
        <Button
          onClick={onCancel}
          variant="outline"
          style={{
            backgroundColor: theme.backgroundColor,
            color: theme.textColor,
            borderColor: theme.inputBorderColor,
            borderRadius: theme.buttonBorderRadius,
            padding: theme.buttonPadding,
            fontWeight: theme.buttonFontWeight,
            transitionDuration: theme.transitionSpeed,
            '--btn-bg-hover': theme.primaryColor,
          } as React.CSSProperties}
        >
          Annulla
        </Button>
        <Button
          onClick={onParse}
          className="hover:bg-[var(--btn-bg-hover)]"
          style={{
            backgroundColor: theme.primaryColor,
            color: theme.textPrimaryColor,
            borderRadius: theme.buttonBorderRadius,
            padding: theme.buttonPadding,
            fontWeight: theme.buttonFontWeight,
            transitionDuration: theme.transitionSpeed,
            '--btn-bg-hover': theme.primaryColorDark || theme.primaryColor,
          } as React.CSSProperties}
        >
          Elabora
        </Button>
      </div>
    </>
  );
};

export default ImportListInput;
